import { __extends } from "tslib";
import { StartSpeechSynthesisTaskInput, StartSpeechSynthesisTaskOutput } from "../models/models_0";
import { deserializeAws_restJson1StartSpeechSynthesisTaskCommand, serializeAws_restJson1StartSpeechSynthesisTaskCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var StartSpeechSynthesisTaskCommand = /** @class */ (function (_super) {
    __extends(StartSpeechSynthesisTaskCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartSpeechSynthesisTaskCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    StartSpeechSynthesisTaskCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PollyClient";
        var commandName = "StartSpeechSynthesisTaskCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: StartSpeechSynthesisTaskInput.filterSensitiveLog,
            outputFilterSensitiveLog: StartSpeechSynthesisTaskOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartSpeechSynthesisTaskCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1StartSpeechSynthesisTaskCommand(input, context);
    };
    StartSpeechSynthesisTaskCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1StartSpeechSynthesisTaskCommand(output, context);
    };
    return StartSpeechSynthesisTaskCommand;
}($Command));
export { StartSpeechSynthesisTaskCommand };
//# sourceMappingURL=StartSpeechSynthesisTaskCommand.js.map